
import { defineComponent } from 'vue'
import CustomUI from './CustomUI.vue'

export default defineComponent({
  inheritAttrs: false,
  components: { CustomUI },
  props: {
    modelValue: {
      type: String
    },
    min: String,
    max: String,
    labelledBy: String
  }
})
